import { POST_API } from ".";
import * as SYSTEM from '../constants/system.keys';

export const getUploadMultiIdApi = async (token, dataHeader, dataBody) => {
  return POST_API(
    `${SYSTEM.SERVER_UPLOAD_MULTIPART_URL}/multipart/initiate`,
    token,
    dataHeader,
    dataBody
  );
};

export const getUploadPreSignPartUrlApi = async (token, dataHeader, dataBody) => {
  return POST_API(
    `${SYSTEM.SERVER_UPLOAD_MULTIPART_URL}/multipart/presign-part`,
    token,
    dataHeader,
    dataBody
  );
}

export const completeUploadMultipartApi = async (token, dataHeader, dataBody) => {
  return POST_API(
    `${SYSTEM.SERVER_UPLOAD_MULTIPART_URL}/multipart/complete`,
    token,
    dataHeader,
    dataBody
  );
}

export const checkCompleteUploadVideoApi = async (token, dataHeader, dataBody) => {
  return POST_API(
    `${SYSTEM.SERVER_UPLOAD_MULTIPART_URL}/multipart/status`,
    token,
    dataHeader,
    dataBody
  );
}

export const getUploadMultipartThumbnailApi = async (token, dataHeader, dataBody) => {
  return POST_API(
    `${SYSTEM.SERVER_UPLOAD_MULTIPART_URL}/uploadLink/thumbnail`,
    token,
    dataHeader,
    dataBody
  );
}

export const reportUploadMultipartApi = async (token, dataHeader, dataBody) => {
  return POST_API(
    `${SYSTEM.SERVER_UPLOAD_MULTIPART_URL}/report-upload`,
    token,
    dataHeader,
    dataBody
  );
}
